import React from 'react';
import { LockKey, Sparkle } from 'phosphor-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { useOptionsEntitlements } from '../../context/OptionsEntitlementsContext';
import { useOptionsLocale } from '../../context/OptionsLanguageContext';

export const OptionsProLockedFeature = ({
  featureKey,
  title,
  description,
  testId,
  compact = false,
}) => {
  const { openUpgradeModal } = useOptionsEntitlements();
  const { isPortuguese } = useOptionsLocale();

  return (
    <Card
      className="border border-white/10 bg-[linear-gradient(135deg,rgba(240,185,11,0.07),rgba(255,255,255,0.025))] text-white shadow-none"
      data-testid={testId}
    >
      <CardContent className={compact ? 'p-5' : 'p-6 sm:p-8'}>
        <div className={`flex ${compact ? 'items-start' : 'flex-col items-start sm:flex-row sm:items-center'} gap-4`}>
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg border border-[#F0B90B]/25 bg-[#F0B90B]/10 text-[#F0B90B]" data-testid={`${testId}-icon`}>
            <LockKey size={21} weight="fill" />
          </div>
          <div className="min-w-0 flex-1">
            <div className="flex flex-wrap items-center gap-2">
              <span className="inline-flex items-center gap-1 rounded-md border border-[#F0B90B]/25 bg-[#F0B90B]/10 px-2 py-1 text-[10px] font-bold uppercase text-[#F0B90B]" data-testid={`${testId}-badge`}>
                <Sparkle size={11} weight="fill" /> PRO
              </span>
              <h2 className="text-base font-bold text-white" data-testid={`${testId}-title`}>{title}</h2>
            </div>
            <p className="mt-2 text-sm leading-relaxed text-white/55" data-testid={`${testId}-description`}>{description}</p>
          </div>
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={() => openUpgradeModal(featureKey)}
            className="shrink-0 border-[#F0B90B]/30 bg-[#F0B90B]/10 text-[#F0B90B] hover:bg-[#F0B90B]/15 hover:text-[#F6C94D]"
            data-testid={`${testId}-upgrade-button`}
          >
            {isPortuguese ? 'Conhecer PRO' : 'Explore PRO'}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};